module.exports = __webpack_public_path__ + "img/app.b08e52ab.svg";